import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { IdentityService } from '../identity.service';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.scss']
})
export class LoginLayoutComponent implements OnInit {
  constructor(
    public fireAuth: AngularFireAuth,
    private identity: IdentityService
  ) {}

  public ngOnInit(): void {}

  public loginWithGoogle() {
    this.fireAuth.auth
      .signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then(() => this.identity.handleAuthenticationReroute());
  }

  public loginWithEmail() {
    // redirect to new page
  }

  public loginWithPhone() {
    // redirect to new page
  }
}
